module.exports = __webpack_public_path__ + "img/banner_5.b3f30794.jpg";